export const fields = [
    {
        label: "Name",
        key: "name",
        sortable: true,
    },
    {
        label: "Description",
        key: "description",
        sortable: false,
    },
    {
        label: "Synopsis",
        key: "synopsis",
        sortable: false,
    },
    {
        label: "",
        key: "is_unrestricted",
        sortable: false,
    },
    {
        label: "",
        key: "buttons",
        sortable: false,
    },
];
